// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-nvs","largestCol":"styles_largestCol__695k3","smallestCol":"styles_smallestCol__3fYD4"};